/* eslint-disable import/no-cycle */
// import { Link } from 'react-router-dom'
// import { useEffect } from 'react'
// import { useNavigate } from 'react-router-dom'
import { Controller } from 'react-hook-form'
import {
  BaseEdit,
  ButtonIcon,
  ButtonNewUser,
  // ButtonIcon,
  // ButtonNewUser,
  Div,
  DivInput,
  FormLogin,
  InputStyle,
  Search,
  Span,
  // Td,
} from './UsersAdm.style'
import { SearchIcon } from '../../assets/icons/search'
import { colors } from '../../theme'

import { ContainerTitle, DivTitle } from '../../components/TitlePage/TitlePage'
import { useUsersAdm } from './useUsersAdm'
import {
  Container,
  // SpanIcon,
  // FilterStatus,
  // SpanFilter,
  // Ul,
} from '../../layouts/LayoutTable/LayoutTable'
// import { FilterIcon } from '../../assets/icons/filter'
// import { ItemFilter } from '../../components/ItemFilter/ItemFilter'
import { GenericTable } from '../../components/GenericTable/GenericTable'

// import { Button } from '../../components/SideBar/Menu.style'
import { Pagination } from '../../components/Pagination/Pagination'
import { Loading } from '../../components/Loading/Loading'
// import { PlusIcon } from '../../assets/icons/Plus'
// import ToggleSwitch from '../../components/Switch/Switch'
// import { Tour } from '../../components/Tour'
// import TourNovoUsuario from '../../utils/JoyRide/tourNovoUsuario'
// import { EditIcon } from '../../assets/icons/EditIcon'
import { EditIcon } from '../../assets/icons/EditIcon'
import ToggleSwitch from '../../components/Switch/Switch'
import { PlusIcon } from '../../assets/icons/Plus'
import { Desativar } from '../../components/Desativar'
// import Tooltips from '../../components/Tooltip'

export function UsersAdm() {
  const {
    searchValue,
    setSearchValue,
    // check,
    // setCheck,
    // isShowFilter,
    currentPage,
    setCurrentPage,
    users,
    fetchUsers,
    isLoading,
    handleKeyDown,
    // goToPage,
    // showFilter,
    // showSend,
    control,
    goToPage,
    handleEdit,
    handleClear,
    ativar,
    desativar,
    modalInativar,
    showInativar,
    setUserId,
    status,
    setStatus,
  } = useUsersAdm()

  return (
    <>
      <DivTitle id="saudacaoUsuariosPermissoes" color="black" size={22}>
        <ContainerTitle>
          Usuários
          {/* <Tooltips icon={<Tour steps={TourNovoUsuario} />} text="Tour" /> */}
        </ContainerTitle>
      </DivTitle>
      <Container>
        <DivInput>
          <Search>
            <InputStyle
              value={searchValue}
              onChange={event => setSearchValue(event.target.value)}
              onKeyDown={handleKeyDown}
              border={colors.grey300}
              placeholder="Pesquise por usuário"
              sizeX="264px"
              sizeY="42px"
            />

            <ButtonNewUser
              type="button"
              // onClick={fetchSales}
              onClick={() => {
                goToPage('/new-user-adm')
                handleClear()
              }}
            >
              <PlusIcon /> Novo
            </ButtonNewUser>
          </Search>
          <Span onClick={fetchUsers}>
            <SearchIcon />
          </Span>
          {/* <SpanIcon onClick={showFilter}>
      <FilterIcon />
    </SpanIcon> */}
          <div>
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              <>
                <GenericTable
                  size="270px"
                  headers={[
                    'Nome',
                    'E-mail',
                    'Nível de acesso',
                    'Bloquear',
                    // 'Empresas',
                    // 'Status',
                    // 'Editar',
                  ]}
                  spacing="40px"
                  font="16px"
                  vendas
                  text
                >
                  {users.content &&
                    users.content.map(user => (
                      <tr
                        // onClick={() => goToPage(user.id)}
                        className=""
                        key={user.id}
                      >
                        <td className="colVendas7">{user.nome}</td>
                        <td className="colVendas7">{user.email}</td>
                        <td className="colVendas7">
                          {user.papel === 'ADMINISTRADOR'
                            ? 'Administrador'
                            : 'Usuário'}
                        </td>
                        <td className="colVendas6">
                          {/* <Td classification={user.ativo}>
                          {user.ativo ? 'Sim' : 'Não'}
                        </Td> */}
                          <Div>
                            <FormLogin id="ativoInativo">
                              {/* <LabelLSwitch htmlFor="name">Situação</LabelLSwitch> */}
                              <Controller
                                name="isActive"
                                control={control}
                                render={({ field: { ref, ...field } }) => (
                                  <ToggleSwitch
                                    adm
                                    checked={user.ativo}
                                    onClick={() => {
                                      setUserId(user.id)
                                      setStatus(user.ativo)
                                      showInativar()
                                    }}
                                    id="status"
                                    // label={statusLabel}
                                    {...field}
                                  />
                                )}
                              />
                            </FormLogin>
                            <BaseEdit>
                              <ButtonIcon
                                type="button"
                                onClick={() => {
                                  handleEdit(user)
                                  goToPage('/new-user-adm')
                                }}
                              >
                                <EditIcon />
                              </ButtonIcon>
                            </BaseEdit>
                          </Div>
                        </td>

                        {/* <td className="col3">
                          <ButtonIcon
                            type="button"
                            onClick={() => {
                              setDados(true)
                              setUsuario(user)
                            }}
                          >
                            <EditIcon />
                          </ButtonIcon>
                        </td> */}

                        {/* <td className="colVendas7">Izap, LinkCom, W3ERP</td>
                        <td className="colIcon">
                          {user.email ? (
                            <Div>
                              <ToggleSwitch
                                id={String(user.id)}
                                checked
                                disabled
                              />
                              <Link className="editPermissoes" to="/newUser">
                                <EditIcon />
                              </Link>
                            </Div>
                          ) : (
                            <Div>
                              <ToggleSwitch
                                id={String(user.id)}
                                checked={false}
                                disabled
                              />
                              <Link className="editPermissoes" to="/newUser">
                                <EditIcon />
                              </Link>
                            </Div>
                          )}
                        </td> */}
                      </tr>
                    ))}
                </GenericTable>
                <Pagination
                  pageNumber={currentPage}
                  pageSize={users.totalElements}
                  offSet={users.size}
                  onClick={page => setCurrentPage(page)}
                />
              </>
            )}
          </div>
        </DivInput>

        {/* {isShowFilter ? (
      <FilterStatus>
        <SpanFilter>Filtrar por:</SpanFilter>
        <div>
          <Ul>
            <ItemFilter
              checked={check === 0}
              onChange={() => setCheck(0)}
              text="Todos"
              id="all"
            />
            <ItemFilter
              checked={check === 1}
              onChange={() => setCheck(1)}
              text="Em alta"
              id="onHigh"
            />
            <ItemFilter
              checked={check === 2}
              onChange={() => setCheck(2)}
              text="Em baixa"
              id="low"
            />
          </Ul>
        </div>
        <Button buttonType="SMALL" type="button" onClick={fetchUsers}>
          Aplicar
        </Button>
      </FilterStatus>
    ) : null} */}
      </Container>
      {modalInativar && (
        <Desativar
          botaoNao={showInativar}
          botaoSim={status ? desativar : ativar}
          texto={
            status
              ? 'Deseja realmente desativar este usuário?'
              : 'Deseja realmente ativar este usuário?'
          }
        />
      )}
    </>
  )
}
